import { inject } from "@angular/core";
import { RoleType } from "src/app/shared/enums/user/role-types.enum";
import { StoreService } from "src/app/shared/services/store/store.service";


export interface IAdminMenuItem {
  path?: string;
  title: string;
  icon: string;
  subItems?: IAdminMenuItem[];
  showFor?: RoleType[]; // zobrazit pouze pro tyto role ve vybrane org
  showHasAnywhere?: RoleType; // pokud má v jakekoli organizaci tuto roli, tak zobraz vždy
  showForAll?: boolean; // zobrazit vzdy
  isQuickMobileItem?: boolean; // zobrazi se v rychlém menu na mobilu
  action?: () => void; // akce, která se provede po kliknutí na položku menu
}

export interface IAdminMenuSection {
  title: string;
  subItems: IAdminMenuItem[]
  showFor?: RoleType[];
}

export function getAdminMenuItems(store: StoreService): IAdminMenuItem[] {
  return [
    {
      path: 'sys-admin/dashboard',
      title: 'admin.menu.sys-admin-dashboard',
      icon: 'pi pi-home',
      showFor: [ RoleType.SYSTEM_ADMIN ]
    },

    {
      path: 'org-admin/events',
      title: 'admin.menu.events', // 'Nabídky a události'
      icon: 'pi pi-calendar',
      showFor: [ RoleType.ORG_OWNER, RoleType.ORG_ADMIN, RoleType.COORDINATOR, RoleType.SYSTEM_ADMIN ]
    },

    {
      path: 'org-admin/reservations',
      title: 'admin.menu.reservations', // 'Rezervace a nákupy'
      icon: 'pi pi-shopping-cart',
      showFor: [ RoleType.ORG_OWNER, RoleType.ORG_ADMIN, RoleType.COORDINATOR, RoleType.SYSTEM_ADMIN ]
    },

    {
      path: 'org-admin/customers',
      title: 'admin.menu.customers', // 'Zákazníci'
      icon: 'pi pi-users',
      showFor: [ RoleType.ORG_OWNER, RoleType.ORG_ADMIN, RoleType.SYSTEM_ADMIN, RoleType.COORDINATOR ]
    },

    {
      path: 'org-admin/payments',
      title: 'admin.menu.payments', // 'Platby a doklady'
      icon: 'pi pi-money-bill',
      showFor: [ RoleType.ORG_OWNER, RoleType.ORG_ADMIN, RoleType.COORDINATOR, RoleType.SYSTEM_ADMIN ]
    },

    {
      path: 'org-admin/attendance/lessons-overview',
      title: 'admin.menu.sessions', // 'Plán lekcí a setkání'
      icon: 'pi pi-bars',
      showFor: [ RoleType.ORG_OWNER, RoleType.ORG_ADMIN, RoleType.COORDINATOR, RoleType.SYSTEM_ADMIN ]
    },
    {
      path: 'org-admin/messages',
      title: 'admin.menu.messages', // 'Zprávy'
      icon: 'pi pi-envelope',
      showFor: [ RoleType.ORG_OWNER, RoleType.ORG_ADMIN, RoleType.COORDINATOR, RoleType.SYSTEM_ADMIN ]
    },
    {
      path: 'org-admin/org-users',
      title: 'admin.menu.team', // 'Tým a role'
      icon: 'pi pi-sitemap',
      showFor: [ RoleType.ORG_OWNER, RoleType.ORG_ADMIN, RoleType.COORDINATOR, RoleType.SYSTEM_ADMIN ]
    },
    {
      path: 'org-admin/locations',
      title: 'admin.menu.locations', // 'Lokace'
      icon: 'pi pi-map-marker',
      showFor: [ RoleType.ORG_OWNER, RoleType.ORG_ADMIN, RoleType.COORDINATOR, RoleType.SYSTEM_ADMIN ]
    },
    {
      path: 'org-admin/settings',
      title: 'admin.menu.settings', // 'Nastavení organizace'
      icon: 'pi pi-cog',
      showFor: [ RoleType.ORG_OWNER, RoleType.ORG_ADMIN, RoleType.SYSTEM_ADMIN ]
    },

    {
      path: 'lecturer/calendar', 
      title: 'admin.menu.teacher.calendar', 
      icon: 'pi pi-calendar',
      showFor: [ RoleType.LECTURER ],
      isQuickMobileItem: true
    },
    {
      path: 'lecturer/session-groups',
      title: 'admin.menu.teacher.my-courses', 
      icon: 'pi pi-calendar',
      showFor: [ RoleType.LECTURER ],
    },
    {
      title: 'admin.menu.teacher.substitute', 
      icon: 'pi pi-sync',
      showFor: [ RoleType.LECTURER ],
      isQuickMobileItem: true,
      action: () => {
        store.actions.adminMenu_openSubstituteModal$.next();
      }
    },

    // { not used anymore, replaced by new calendar
    //   path: 'lecturer/sessions', //todo: mělo by být teacher/sessions
    //   title: 'admin.menu.teacher.sessions', // 'Moje lekce'
    //   icon: 'pi pi-calendar',
    //   showFor: [ RoleType.LECTURER ],
    // },
    {
      path: 'lecturer/profile',
      title: 'admin.menu.teacher.profile',//'Můj profil',
      icon: 'pi pi-cog',
      showFor: [ RoleType.LECTURER ],
      isQuickMobileItem: true
    },

    // {
    //   path: 'coordinator/dashboard',
    //   title: 'Dashboard',
    //   icon: 'pi pi-home',
    //   showFor: [ RoleType.COORDINATOR ]
    // },

    // {
    //   path: 'customer/my-orders',
    //   title: 'admin.menu.customer.orders',//'Moje objednávky', //todo add | translate
    //   icon: 'pi pi-shopping-cart',
    //   showHasAnywhere: RoleType.CUSTOMER,
    // }
  ];
}

// export const ADMIN_MENU_QUICK_MOBILE_ITEMS: IAdminMenuItem[] = ADMIN_MENU_ITEMS.filter(x => x.isQuickMobileItem);